import { Navigate, useLocation } from 'react-router-dom';
import { tokenStore } from '@/api/client';
import { useSessionSync } from '@/hooks/useAuth';

interface Props {
  children: React.ReactNode;
  kind?: 'user' | 'merchant';
}

export function ProtectedRoute({ children }: Props) {
  const loc = useLocation();
  const hasToken = !!tokenStore.get();

  // Re-read permissions from the server once per page load, so a module granted after this person
  // last signed in shows up on a refresh instead of only after a full logout.
  useSessionSync();

  console.log('[ProtectedRoute] path=', loc.pathname, 'hasToken=', hasToken);

  if (!hasToken) {
    console.log('[ProtectedRoute] BOUNCING to /login (no token)');
    return <Navigate to="/login" replace state={{ from: loc }} />;
  }

  console.log('[ProtectedRoute] ALLOWING through');
  return <>{children}</>;
}
